import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=857228ac&scoped=true&lang=less"

import exportComponent from "/Users/baron/Desktop/New-OnlineServiceCenter/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-857228ac"]])

export default __exports__